import { CloseRounded, SearchOutlined } from "@mui/icons-material";
import { $crud } from "../utils/CrudFactory";
import {
  Box,
  CircularProgress,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Clientslist from "./globalSearch/Clientslist";
import Orderlist from "./globalSearch/Orderlist";
import RegularOfferlist from "./globalSearch/RegularOfferlist";
import HelpOfferlist from "./globalSearch/HelpOfferslist";
import Driverslist from "./globalSearch/Driverslist";
import axios from "axios";
import { BASE_URL } from "../constants";
import { useOutside } from "../hooks/useOutside";
import { useAdmin } from "./AdminProvider";

function GlobalSearch() {
  const [searchTearm, setSearchTerm] = useState("");
  const [result, setResult] = useState({});
  const [loading, setLoading] = useState(false);
  const refe = useOutside(clearSearch);

  useEffect(() => {
    if (searchTearm.length < 2) {
      setResult({});
      return;
    }
    const id = setTimeout(() => {
      setLoading(true);
      axios
        .get(
          `${BASE_URL}api/retrieve/admin/global-search?search=${searchTearm}`,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          setResult(res.data.data);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 300);

    return () => {
      clearTimeout(id);
    };
  }, [searchTearm]);

  function clearSearch() {
    setResult({});
    setSearchTerm("");
  }

  return (
    <Box
      ref={refe}
      sx={{ position: "relative", width: { xs: "inherit", md: "70%" } }}
    >
      <TextField
        value={searchTearm}
        onChange={(e) => setSearchTerm(e.target.value)}
        name="search"
        placeholder="Search Across The App"
        sx={{
          width: "90%",
          color: "#1C1B1F",
          "& .MuiInputLabel-root": {
            color: "#1C1B1F !important", // Adding !important to ensure the color overrides
          },
          "& .MuiOutlinedInput-root": {
            paddingTop: "5px", // Increase padding
            paddingBottom: "5px", // Increase padding
            "& fieldset": {
              borderColor: "#673C8E", // Initial border color
              borderWidth: "1px", // Increase border width
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              borderColor: "#673C8E", // Change outlined border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#673C8E", // Change outlined border color when focused
            },
          },
        }}
        size="small"
        id="email"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              {searchTearm.length > 0 ? (
                <CloseRounded
                  onClick={clearSearch}
                  sx={{
                    borderRadius: "3px",
                    "&:active": {
                      backgroundColor: "#673C8E0F", // new background on hover
                    },
                  }}
                />
              ) : (
                <SearchOutlined />
              )}
            </InputAdornment>
          ),
        }}
      />
      {searchTearm.length > 1 && (
        <Box
          sx={{
            position: "absolute",
            marginTop: "10px",
            width: "90%",
            maxHeight: "85vh",
            backgroundColor: "white",
            zIndex: 100,
            padding: "16px",
            borderRadius: "6px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            overflowY: "scroll",
          }}
        >
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress size={25} sx={{ color: "#683C8C" }} />
            </div>
          ) : (
            <>
              <Driverslist result={result} clearSearch={clearSearch} />
              <Clientslist result={result} clearSearch={clearSearch} />
              <Orderlist result={result} clearSearch={clearSearch} />
              <RegularOfferlist result={result} clearSearch={clearSearch} />
              <HelpOfferlist result={result} clearSearch={clearSearch} />
            </>
          )}
        </Box>
      )}
    </Box>
  );
}

export default GlobalSearch;
